import React from "react";
import { Controller } from "react-hook-form";
import clsx from "clsx";
import s from "./Switch.less";

interface ISwitchProps {
  control: any;
  name: string;
  disabled?: boolean;
  defaultValue?: boolean;
  onChange?: (value: boolean) => void; // Add onChange prop
}

const Switch: React.FC<ISwitchProps> = ({
  control,
  name,
  disabled,
  defaultValue = false,
  onChange,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ value, onChange: onFormChange }) => {
        return (
          <label className={clsx(s.switch, { [s.disabled]: disabled })}>
            <input
              type="checkbox"
              name={name}
              checked={!!value}
              onChange={(e) => {
                const newValue = e.target.checked;
                onFormChange(newValue); // Update react-hook-form state
                if (onChange) {
                  onChange(newValue); // Call the custom onChange handler
                }
              }}
              disabled={disabled}
            />
            <span className={s.slider}></span>
          </label>
        );
      }}
    />
  );
};

export default Switch;
